import { DownloadIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

/** A plain anchor, not a fetch: the proxy passes Content-Disposition through and the browser streams to disk. */
export function CsvDownloadButton({
  path,
  params,
  label = "Download CSV",
}: {
  path: string;
  params: URLSearchParams;
  label?: string;
}) {
  const withFormat = new URLSearchParams(params);
  withFormat.set("Format", "csv");

  return (
    <Button asChild variant="outline" size="sm">
      <a href={`/api/proxy${path}?${withFormat.toString()}`} download>
        <DownloadIcon className="size-4" />
        {label}
      </a>
    </Button>
  );
}
